import React, { useState, useEffect } from "react";
import { Page, Card, Button } from "tabler-react";
import { Modal } from "react-bootstrap";
import SiteWrapper from "../../SiteWrapper";
import * as productServices from "../../store/services/productServices";
import { BACKENDURL } from "../../store/services/type";

function CustomerViewProduct(props) {
    const [loading, setLoading] = useState(false);
    const [product, setProduct] = useState(null);
    const [activeTab, setActiveTab] = useState("description");
    const [activeImage, setActiveImage] = useState(0);
    const [lightbox, setLightbox] = useState(false);
    const [dimUnit, setDimUnit] = useState("cm");
    const [activeVariant, setActiveVariant] = useState(-1);

    const currentImages = (activeVariant >= 0 && product?.variants?.[activeVariant]?.images?.length > 0)
        ? product.variants[activeVariant].images
        : (product?.images || []);
    const currentPrice = (activeVariant >= 0 && product?.variants?.[activeVariant]?.price) || product?.price;
    const currentUrl   = (activeVariant >= 0 && product?.variants?.[activeVariant]?.url)   || product?.url;

    const selectVariant = (index) => {
        setActiveVariant(index);
        setActiveImage(0);
    };

    useEffect(() => {
        setLoading(true);
        productServices
            .getProduct(props.match.params.id)
            .then((res) => {
                const data = JSON.parse(res.data);
                setProduct(data.data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [props.match.params.id]);

    return (
        <SiteWrapper loading={loading}>
            <Page.Content>
                <div className="page-header d-flex justify-content-between align-items-center">
                    <h1 className="page-title">Product Details</h1>
                    <Button color="secondary" onClick={() => props.history.push("/my-products")}>
                        Back
                    </Button>
                </div>

                <div style={{ display: "flex", flexWrap: "wrap", gap: 24, alignItems: "flex-start" }}>
                    {/* Images */}
                    <div style={{ flex: "0 0 auto", width: "100%", maxWidth: 460, minWidth: 280 }}>
                        <Card className="mb-0">
                            <div
                                onClick={() => currentImages.length > 0 && setLightbox(true)}
                                style={{
                                    height: 320,
                                    backgroundColor: "#f6f6f6",
                                    borderRadius: "4px 4px 0 0",
                                    overflow: "hidden",
                                    cursor: currentImages.length > 0 ? "zoom-in" : "default",
                                    position: "relative",
                                }}
                            >
                                {currentImages.length > 0 ? (
                                    <>
                                        <img
                                            src={`${BACKENDURL}storage/${currentImages[activeImage]}`}
                                            alt={product?.product || ""}
                                            style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                        />
                                        <div style={{
                                            position: "absolute", bottom: 12, right: 12,
                                            backgroundColor: "rgba(0,0,0,0.4)", borderRadius: 6,
                                            padding: "6px 10px", display: "flex", alignItems: "center",
                                        }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                                                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                                                <line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/>
                                            </svg>
                                        </div>
                                    </>
                                ) : (
                                    <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#B3B3B3" strokeWidth="1.5">
                                            <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
                                        </svg>
                                    </div>
                                )}
                            </div>
                            {currentImages.length > 1 && (
                                <Card.Body style={{ padding: "12px 16px" }}>
                                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                                        {currentImages.map((img, i) => (
                                            <div
                                                key={i}
                                                onClick={() => setActiveImage(i)}
                                                style={{
                                                    width: 64, height: 64, borderRadius: 8, overflow: "hidden", cursor: "pointer",
                                                    border: activeImage === i ? "2px solid #2B9A99" : "1px solid #e0e0e0",
                                                }}
                                            >
                                                <img src={`${BACKENDURL}storage/${img}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                            </div>
                                        ))}
                                    </div>
                                </Card.Body>
                            )}
                        </Card>
                    </div>

                    {/* Details */}
                    <div style={{ flex: "1 1 320px", minWidth: 280 }}>
                        <Card className="mb-0" style={{ height: "100%" }}>
                            <Card.Body style={{ padding: "28px 28px" }}>
                                {product?.unique_id && (
                                    <div className="cpd-sku">SKU: {product.unique_id}</div>
                                )}
                                <h2 className="cpd-title">{product?.product}</h2>
                                {currentPrice && (
                                    <div className="cpd-price">£{currentPrice}</div>
                                )}

                                {/* Colour variant swatches */}
                                {product?.variants?.length > 0 && (
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 20 }}>
                                        <button
                                            onClick={() => selectVariant(-1)}
                                            style={{
                                                padding: "6px 16px", borderRadius: 20, fontSize: 13, fontWeight: 500, cursor: "pointer",
                                                border: activeVariant === -1 ? "2px solid #2B9A99" : "1px solid #d0d0d0",
                                                backgroundColor: activeVariant === -1 ? "#f0fafa" : "#fff",
                                                color: activeVariant === -1 ? "#2B9A99" : "#555",
                                            }}
                                        >Base</button>
                                        {product.variants.map((v, i) => (
                                            <button
                                                key={i}
                                                onClick={() => selectVariant(i)}
                                                style={{
                                                    padding: "6px 16px", borderRadius: 20, fontSize: 13, fontWeight: 500, cursor: "pointer",
                                                    border: activeVariant === i ? "2px solid #2B9A99" : "1px solid #d0d0d0",
                                                    backgroundColor: activeVariant === i ? "#f0fafa" : "#fff",
                                                    color: activeVariant === i ? "#2B9A99" : "#555",
                                                }}
                                            >{ v.label || `Colour ${i + 1}` }</button>
                                        ))}
                                    </div>
                                )}

                                {/* Tabs */}
                                <div style={{ display: "flex", borderBottom: "2px solid #e0e0e0", marginBottom: 20 }}>
                                    {["description", "features"].map((tab) => (
                                        <div
                                            key={tab}
                                            onClick={() => setActiveTab(tab)}
                                            className="cpd-tab"
                                            style={{
                                                color: activeTab === tab ? "#2B9A99" : "#B3B3B3",
                                                borderBottom: activeTab === tab ? "2px solid #2B9A99" : "2px solid transparent",
                                                marginBottom: -2,
                                            }}
                                        >
                                            {tab}
                                        </div>
                                    ))}
                                </div>

                                <div className="cpd-body">
                                    {activeTab === "description" && (product?.description || "—")}
                                    {activeTab === "features" && (
                                        product?.features
                                            ? product.features.split("\n").map((f, i) => f.trim() && (
                                                <div key={i} className="cpd-body-item">• {f.trim()}</div>
                                            ))
                                            : "—"
                                    )}
                                </div>

                                {/* Dimensions */}
                                {(product?.width || product?.height || product?.depth || product?.weight) && (
                                    <div style={{ marginTop: 20, padding: "14px 18px", backgroundColor: "#f6f6f6", borderRadius: 10 }}>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                                            <div className="cpd-dim-label" style={{ marginBottom: 0 }}>Dimensions</div>
                                            <div style={{ display: "flex", borderRadius: 6, overflow: "hidden", border: "1px solid #d0d0d0", fontSize: 12 }}>
                                                {["cm", "in"].map(u => (
                                                    <button
                                                        key={u}
                                                        onClick={() => setDimUnit(u)}
                                                        style={{
                                                            padding: "3px 10px", border: "none", cursor: "pointer",
                                                            backgroundColor: dimUnit === u ? "#2B9A99" : "#fff",
                                                            color: dimUnit === u ? "#fff" : "#666",
                                                            fontWeight: dimUnit === u ? 600 : 400,
                                                            transition: "background 0.15s",
                                                        }}
                                                    >{u}</button>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="cpd-dim-value">
                                            {product?.width  && <span>W: {dimUnit === "cm" ? product.width : (parseFloat(product.width) / 2.54).toFixed(1)}{dimUnit}</span>}
                                            {product?.height && <span>H: {dimUnit === "cm" ? product.height : (parseFloat(product.height) / 2.54).toFixed(1)}{dimUnit}</span>}
                                            {product?.depth  && <span>D: {dimUnit === "cm" ? product.depth : (parseFloat(product.depth) / 2.54).toFixed(1)}{dimUnit}</span>}
                                            {product?.weight && <span>Weight: {product.weight}kg</span>}
                                        </div>
                                    </div>
                                )}

                                {/* Buy button */}
                                {currentUrl && (
                                    <a href={currentUrl} target="_blank" rel="noopener noreferrer" className="cpd-buy">
                                        Buy{currentPrice ? ` — £${currentPrice}` : ""}
                                    </a>
                                )}
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </Page.Content>

            <Modal show={lightbox} onHide={() => setLightbox(false)} centered size="xl" dialogClassName="lightbox-modal" contentClassName="lightbox-content">
                <Modal.Body style={{ backgroundColor: "transparent", padding: 0, position: "relative" }}>
                    <div
                        onClick={() => setLightbox(false)}
                        style={{
                            position: "absolute", top: 12, right: 12, zIndex: 10, cursor: "pointer",
                            backgroundColor: "rgba(0,0,0,0.6)", borderRadius: "50%", width: 44, height: 44,
                            display: "flex", alignItems: "center", justifyContent: "center",
                        }}
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5">
                            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                    </div>

                    {currentImages.length > 1 && (
                        <div
                            onClick={() => setActiveImage(i => (i - 1 + currentImages.length) % currentImages.length)}
                            style={{
                                position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", zIndex: 10,
                                cursor: "pointer", backgroundColor: "rgba(0,0,0,0.6)", borderRadius: "50%",
                                width: 48, height: 48, display: "flex", alignItems: "center", justifyContent: "center",
                            }}
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5">
                                <polyline points="15 18 9 12 15 6"/>
                            </svg>
                        </div>
                    )}

                    <img
                        src={currentImages[activeImage] ? `${BACKENDURL}storage/${currentImages[activeImage]}` : ""}
                        alt={product?.product || ""}
                        style={{ width: "100%", maxHeight: "85vh", objectFit: "contain", display: "block" }}
                    />

                    {currentImages.length > 1 && (
                        <div
                            onClick={() => setActiveImage(i => (i + 1) % currentImages.length)}
                            style={{
                                position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", zIndex: 10,
                                cursor: "pointer", backgroundColor: "rgba(0,0,0,0.6)", borderRadius: "50%",
                                width: 48, height: 48, display: "flex", alignItems: "center", justifyContent: "center",
                            }}
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5">
                                <polyline points="9 18 15 12 9 6"/>
                            </svg>
                        </div>
                    )}

                    {currentImages.length > 1 && (
                        <div style={{ display: "flex", justifyContent: "center", gap: 8, padding: "14px 0 18px" }}>
                            {currentImages.map((_, i) => (
                                <div
                                    key={i}
                                    onClick={() => setActiveImage(i)}
                                    style={{
                                        width: 10, height: 10, borderRadius: "50%", cursor: "pointer",
                                        backgroundColor: activeImage === i ? "#fff" : "rgba(255,255,255,0.3)",
                                    }}
                                />
                            ))}
                        </div>
                    )}
                </Modal.Body>
            </Modal>

        </SiteWrapper>
    );
}

export default CustomerViewProduct;
